import { useMutation } from '@tanstack/react-query';

import { OcrLabIdVerificationRequest } from '../../../../types/requests';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postOcrLabIdVerification } from '../../requests/postOcrLabIdVerification';

export const useOcrLabIdVerification = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: OcrLabIdVerificationRequest) =>
      postOcrLabIdVerification(constructPost, data),
    onSuccess: () => handleSuccess('IDVerse verification has been sent'),
    onError: () => handleError('IDVerse verification failed'),
  });
  return { postOcrLabIdVerification: mutateAsync, ...rest };
};
